var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.004V8h19v8.05a4.448 4.448 0 0 1 1 .226V3.004h-6v-2H7v2H1V19h8.344a3.526 3.526 0 0 1 .717-.996zM8 2h7v1.004H8zM2 4h19v3.004H2zm18.5 13a3.494 3.494 0 0 0-3.45 3h-2.1A2.502 2.502 0 0 0 13 18.05v-4.1a2.477 2.477 0 0 0 1.002-.463L16.338 16H15v1h3v-3h-1v1.243l-2.336-2.512A2.473 2.473 0 0 0 15 11.5a2.5 2.5 0 1 0-3 2.45v4.1A2.5 2.5 0 1 0 14.95 21h2.1a3.493 3.493 0 1 0 3.45-4zM11 11.5a1.5 1.5 0 1 1 1.5 1.5 1.502 1.502 0 0 1-1.5-1.5zM12.5 22a1.5 1.5 0 1 1 1.5-1.5 1.502 1.502 0 0 1-1.5 1.5zm8 1a2.5 2.5 0 1 1 2.5-2.5 2.502 2.502 0 0 1-2.5 2.5zm1.5-2.5a1.5 1.5 0 1 1-1.5-1.5 1.502 1.502 0 0 1 1.5 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.a506ddfe7f0c60942a57cd7b7ef40883.svg";
export { ForwardRef as ReactComponent };